<p [innerHTML]="guestConfigurationMessage | safeHTMLUrl"></p>
